module.exports = __webpack_public_path__ + "static/media/sigma.4ca5dd32.svg";